// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Gnf7W","body":"styles_body__WsrMr","actions":"styles_actions__v-ZSo"};